import * as _ from "lodash";
import * as echarts from "echarts";
import { portfolioSelectorService } from "../portfolioSelector";
import { PortfolioUtilities } from "@common/portfolio.utilities";
import { AggregatePortfolioItem } from "@models/portfolio/aggregatePortfolioItem";
import { GraphColourArray } from "@common/enums/GraphColours";

class SummaryViewController implements angular.IOnInit, angular.IPostLink {
  public getData: () => angular.IPromise<AggregatePortfolioItem[]>;

  public heading: string;
  public icon: string;
  public cardColour: string;
  public summaryTotal: number;
  public summaryItems: AggregatePortfolioItem[];

  // colour array
  public colourArray: string[] = GraphColourArray;

  private summaryPieChart: any;
  private pieChartOptions: any;

  private minScreenWidth = 400;

  /** @ngInject */
  constructor(
    private portfolioUtilities: PortfolioUtilities,
    private $scope: angular.IScope,
    private portfolioSelectorService: portfolioSelectorService,
    private notifyjs: any
  ) {}

  $onInit() {
    this.portfolioSelectorService.registerCallback(
      `summaryView.${this.heading}`,
      this.loadData.bind(this)
    ); // Need to wrap it in a fat arrow functiom to get the correctly scoped this

    // cannot set in constructor because binding has not yet happened
    this.loadData();
  }

  $postLink(): void {
    this.summaryPieChart = echarts.init(this.$scope["summary-chart"][0]);
  }

  private loadData() {
    this.portfolioSelectorService.setIsLoading(true);
    this.getData()
      .then((result) => {
        this.summaryItems = _.orderBy(result, (item) => item.name);
        this.summaryTotal = _.reduce(
          this.summaryItems,
          (accumulator, item) => {
            accumulator += item.total;
            return accumulator;
          },
          0
        );
        let count = -1;
        this.pieChartOptions = {
          tooltip: {
            trigger: "item",
            formatter: "{b} : {d}%",
          },
          series: {
            type: "pie",
            radius: ["40%", "70%"],
            center: ["50%", "50%"],
            labelLine: {
              normal: {
                show: window.screen.width > this.minScreenWidth,
              },
            },
            label: {
              normal: {
                show: window.screen.width > this.minScreenWidth,
                fontSize: window.screen.width > 1920 ? 24 : 12,
              },
            },
            data: _.map(this.summaryItems, (item) => {
              count += 1;
              return {
                value: this.getPercentage(item),
                name: item.name,
                itemStyle: {
                  normal: {
                    color: GraphColourArray[count],
                    fontFamily: "Helvetica",
                  },
                },
              };
            }),
          },
        };

        if (this.summaryPieChart) {
          this.summaryPieChart.setOption(this.pieChartOptions);
          // this.colourArray = this.summaryPieChart.getOption().color;
        }
      })
      .finally(() => this.portfolioSelectorService.setIsLoading(false));
  }

  formatCurrency() {
    if (!this.portfolioSelectorService.isLoading) {
      return this.portfolioUtilities.formatCurrency(
        this.portfolioSelectorService.getSelectedCurrency()
      );
    } else {
      return "";
    }
  }

  getPercentage(item: AggregatePortfolioItem) {
    return (item.total / this.summaryTotal) * 100;
  }
}

export const summaryView: angular.IComponentOptions = {
  template: require("./summaryView.html"),
  controller: SummaryViewController,
  bindings: {
    heading: "@",
    icon: "@",
    cardColour: "@",
    getData: "&",
  },
};



// WEBPACK FOOTER //
// ./src/app/portfolio/geographyAndSector/summaryView.ts